var h = Object.defineProperty;
var c = (t, o) => h(t, "name", { value: o, configurable: !0 });
import e from "dayjs";
import { default as lt } from "dayjs";
import g from "dayjs/plugin/utc.js";
import d from "dayjs/plugin/timezone.js";
import $ from "dayjs/plugin/advancedFormat.js";
import x from "dayjs/plugin/localizedFormat.js";
import D from "dayjs/plugin/duration.js";
import A from "dayjs/plugin/isSameOrAfter.js";
import b from "dayjs/plugin/isSameOrBefore.js";
import F from "dayjs/plugin/customParseFormat.js";
import "dayjs/locale/en-gb.js";
import "dayjs/locale/cs.js";
import "dayjs/locale/sk.js";
import "dayjs/locale/pl.js";
import "dayjs/locale/hu.js";
import "dayjs/locale/de.js";
import "dayjs/locale/es.js";
import "dayjs/locale/fr.js";
import y from "sanitize-html";
import { customAlphabet as w } from "nanoid";
import { parse as L, CssTypes as z, stringify as S } from "@adobe/css-tools";
const tt = [
  "in",
  "e",
  "static-api",
  "console",
  "status"
];
e.extend(g);
e.extend(d);
e.extend($);
e.extend(x);
e.extend(D);
e.extend(A);
e.extend(b);
e.extend(F);
e.extend((t, o) => {
  const r = o.prototype.format;
  o.prototype.format = function(m) {
    if (!this.isValid() || !m)
      return r.bind(this)(m);
    const i = m.replaceAll("custom-fullMonthNoYear", () => {
      var a, s;
      return `[${this.utc().toDate().toLocaleString((a = this.$locale) == null ? void 0 : a.call(this).name, {
        timeZone: (s = this.$x) == null ? void 0 : s.$timezone,
        weekday: "long",
        month: "short",
        day: "numeric"
      })}]`;
    });
    return r.bind(this)(i);
  };
});
const T = /* @__PURE__ */ c((t, o) => {
  const r = e(o).tz(e.tz.guess()).utcOffset(), m = e(o).tz(t).utcOffset();
  return r !== m;
}, "hasDeviceDifferentTimezoneOffset"), O = /* @__PURE__ */ c((t) => ["America/", "Australia/", "Pacific/Auckland", "Pacific/Honolulu", "Asia/Dubai"].some((o) => t.startsWith(o)), "hasTimezoneUSFormat"), et = /* @__PURE__ */ c((t = e().format(), o) => {
  const {
    format: r = "LL",
    lang: m = "en",
    timezone: i = e.tz.guess() || "Europe/London",
    showTimezoneDiff: a = !1
  } = o ?? {};
  let s = (o == null ? void 0 : o.langVersion) ?? "timezone";
  const n = typeof t == "string" && e(t).isValid() ? t : null, f = typeof t == "object" && (t != null && t.start) && e(t.start).isValid() ? t.start : null, l = typeof t == "object" && (t != null && t.end) && e(t.end).isValid() ? t.end : null;
  (s === "timezone" || s === "browser") && (m === "en" ? s = O(s === "browser" ? e.tz.guess() : i) ? "US" : "GB" : s = void 0);
  const u = s ? `${m}-${s}` : m;
  if (!n && !(f && l))
    return "";
  const p = a && T(i, f ?? n) ? " (z)" : "";
  return n ? e(n).locale(u).tz(i).format(`${r}${p}`) : f && l && e(f).tz(i).isSame(e(l).tz(i), "day") ? `${e(f).locale(u).tz(i).format(r)} – ${e(l).locale(u).tz(i).format(`LT${p}`)}` : `${e(f).locale(u).tz(i).format(r)} – ${e(l).locale(u).tz(i).format(`${r}${p}`)}`;
}, "getFormattedDate"), ot = /* @__PURE__ */ c((t = "") => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(t).toLowerCase()), "isEmailValid"), rt = /* @__PURE__ */ c((t) => String(t ?? "").normalize("NFD").replace(/[\u0300-\u036F]/g, "").replace(/[^\x00-\x7F]/g, "").toLowerCase().trim(), "normalizeString"), V = {
  ...y.defaults,
  allowedAttributes: {
    a: ["href", "target", "name", "style"],
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"],
    span: ["style"],
    strong: ["style"],
    em: ["style"],
    ul: ["style"]
  },
  parseStyleAttributes: !1
}, st = /* @__PURE__ */ c((t) => y(t ?? "", V), "sanitize"), v = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_", nt = /* @__PURE__ */ c((t = 12) => w(v)(t), "nanoid"), it = /* @__PURE__ */ c((t, o) => {
  try {
    const r = L(t), m = r.stylesheet.rules.map((a) => {
      if (a.type === z.rule) {
        const s = a.selectors.map((n) => n === o ? n : `${o} ${n}`);
        return { ...a, selectors: s };
      }
      if (a.type === z.media) {
        const s = a.rules.map((n) => {
          if (n.type === z.rule) {
            const f = n.selectors.map((l) => l === o ? l : `${o} ${l}`);
            return { ...n, selectors: f };
          }
          return n;
        });
        return { ...a, rules: s };
      }
      return a;
    });
    return S({
      ...r,
      stylesheet: {
        ...r.stylesheet,
        rules: m
      }
    });
  } catch (r) {
    return console.warn("Error parsing custom css", r), "";
  }
}, "prefixCustomCss");
export {
  lt as dayjs,
  et as getFormattedDate,
  T as hasDeviceDifferentTimezoneOffset,
  ot as isEmailValid,
  nt as nanoid,
  rt as normalizeString,
  it as prefixCustomCss,
  tt as reservedDomains,
  st as sanitize
};
